import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';

function getScrollParent(el: HTMLElement | null): HTMLElement | null {
  let node: HTMLElement | null = el;
  while (node) {
    const style = window.getComputedStyle(node);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;
    const isScrollable =
      /(auto|scroll|overlay)/.test(overflowY) || /(auto|scroll|overlay)/.test(overflowX);
    if (isScrollable) return node;
    node = node.parentElement;
  }
  return document.scrollingElement as HTMLElement | null;
}

export const ScrollableTooltip = (props: { children: React.ReactElement; title: string }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const scrollParent = getScrollParent(anchorRef.current);
    if (!scrollParent) return;

    const onScroll = () => setOpen(false);
    scrollParent.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      scrollParent.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <Tooltip
      title={props.title}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={{
        popper: {
          disablePortal: false,
        },
      }}
    >
      <span ref={anchorRef} style={{ display: 'inline-flex' }}>
        {props.children}
      </span>
    </Tooltip>
  );
};
